module.exports = __webpack_public_path__ + "static/media/vacancyRequest.a9a18474.svg";